module.exports = __webpack_public_path__ + "static/media/fade02.c4f30cb5.png";